<script setup lang="ts">
import {Knowledgeable} from "@/knowledge-box/interfaces";
import KnowledgeableChatModal from "@/knowledge-box/components/KnowledgeableChatModal.vue";
import GlowingContainer from "@/core/components/glowing-container/GlowingContainer.vue";
import {createReusableTemplate} from "@vueuse/core";
import {Popover, PopoverContent, PopoverTrigger} from "@/core/components/ui/popover";
import BaseButton from "@/core/components/base/BaseButton.vue";

defineProps<{ knowledgeables: Knowledgeable[] }>();

const [DefineTemplate, ReuseTemplate] = createReusableTemplate();
</script>

<template>
  <DefineTemplate>
    <GlowingContainer>
      <BaseButton density="comfortable" class="text-primary rounded-full">
        Demander conseil à l'IA
      </BaseButton>
    </GlowingContainer>
  </DefineTemplate>

  <div>
    <KnowledgeableChatModal v-if="knowledgeables.length === 1" :knowledgeable="knowledgeables[0]">
      <template #trigger>
        <ReuseTemplate />
      </template>
    </KnowledgeableChatModal>
    <div v-if="knowledgeables.length > 1">
      <Popover>
        <PopoverTrigger>
          <ReuseTemplate />
        </PopoverTrigger>
        <PopoverContent as-child class="w-auto">
          <div class="flex flex-col">
            <div v-for="(knowledgeable, index) in knowledgeables" :key="knowledgeable.id">
              <KnowledgeableChatModal :knowledgeable="knowledgeable">
                <template #trigger>
                  <div
                    class="flex items-center gap-2 hover:bg-gray-100 transition duration-100 px-4 py-2"
                    :class="{
                      'mb-2': index !== knowledgeables.length - 1
                    }"
                  >
                    <div
                      v-if="knowledgeable.knowledge_box.logo"
                      :key="knowledgeable.id"
                      class="h-12 max-w-44 mr-2"
                    >
                      <img :src="knowledgeable.knowledge_box.logo.url" :alt="`logo`" class="object-fill h-full">
                    </div>
                    <div class="block">
                      <p class="text-primary text-sm font-semibold">
                        Poser une question
                      </p>
                      <p class="text-xs">
                        {{ knowledgeable.knowledge_box.title }}
                      </p>
                    </div>
                  </div>
                </template>
              </KnowledgeableChatModal>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  </div>
</template>

<style scoped>
:deep(.prompt input[type="text"]:focus) {
    --tw-ring-shadow: none;
}

:deep(.glowing-container) {
    @apply !rounded-full;
}

:deep(.glowing-container > .content) {
    @apply !rounded-full;
}
</style>
